// extracted by mini-css-extract-plugin
export var redoItem = "_gk-1";
export var redoTrigger = "_gk-0";